/** Shared grow animation — matches Recharts Pie defaults used in closure overview. */
export const CHART_GROW_DURATION_MS = 1500;

export const CHART_GROW_ANIMATION = {
  isAnimationActive: true,
  animationDuration: CHART_GROW_DURATION_MS,
  animationEasing: 'ease',
};

export const CHART_BAR_STAGGER_MS = 120;
